import { Routes, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
import { useSelector, shallowEqual } from 'react-redux';
import { RootState } from './modules';

import GoodRecord from './Components/GoodRecord';
import Home from './Components/Home';
import TomorrowPage from './Components/Tomorrow';
import Portfoilo from './Components/Portfolio';
import Toast from './Components/Common/Toast';
import KaTalkView from './Components/KatalkView';
import Error404 from './Components/Error/404';
import Login from './Components/Login/Login';
import ThemeSwitch from './Components/Common/FixedThemeSwitch';
import Detail from './Components/DetailProjects/Detail';
import SpotifyPage from './Components/GoodRecord/Spotify';
import ErrorBoundary from './Components/Common/ErrorBoundary';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  /* height: 100vh; */

  width: 100%;

  /* justify-content: center; */
  align-items: center;
`;

function App() {
  const location = useLocation();
  const { toastOpen } = useSelector((state: RootState) => ({
    toastOpen: state.toast.isOpen
  }), shallowEqual);

  const hideThemeSwitch = [
    '/goodrecord', 
    '/portfolio'
  ].includes(location.pathname);

  return (
    <ErrorBoundary>
      <div className='App'>
        <HelmetProvider>
          <Wrapper>
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/tomorrow' element={<TomorrowPage />} />
                <Route path='/goodrecord' element={<GoodRecord />} />
                <Route path='/portfolio' element={<Portfoilo />} />
                <Route path='/katalkview' element={<KaTalkView />} />
                <Route path='/login' element={<Login />} />
                <Route path='/spotify' element={<SpotifyPage />} />
                <Route path='/detail/*' element={<Detail />} />
                <Route path='*' element={<Error404 />} />
              </Routes>
              
              {toastOpen && <Toast />}
              {!hideThemeSwitch && <ThemeSwitch />}
            </Wrapper>
          </HelmetProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
